import { registerGoogleUser } from "actions/user";
import LoginPopUp from "components/login";
import RegisterPopUp from "components/register";
import { SuccessCreatePopup } from "components/register/components/SuccessCreatePopup";
import { Header } from "pages/home/components/Header";
import { useState } from "react";
import { createContext, useContext, useEffect } from "react";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";

export const HeaderContext = createContext();

const allowedRoutes = ["/", "/demo"];

export const HeaderProvider = ({ children }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [openLogin, setOpenLogin] = useState(false);
  const [openRegister, setOpenRegister] = useState(false);

  const location = useLocation();

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);

    if (!queryParams) return;
    const login = queryParams.get("login");
    const signUp = queryParams.get("signUp");

    if (login && !openLogin) return setOpenLogin(true);
    if (signUp && !openRegister) return setOpenRegister(true);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location?.search]);

  const [openSuccessSignup, setOpenSuccessSignup] = useState(false);

  const googleResponse = ({ credential }) => {
    dispatch(registerGoogleUser(credential, () => navigate("/genie-gpt")));
  };

  const googleErrorResponse = (error) => {
    console.log(error);
  };

  const allowToShowHeader = allowedRoutes.includes(location.pathname) && location.pathname !== "/genie-gpt";

  return (
    <HeaderContext.Provider value={{ setOpenLogin, setOpenRegister }}>
      <SuccessCreatePopup open={openSuccessSignup} setOpen={setOpenSuccessSignup} />
      {openRegister && (
        <RegisterPopUp
          googleResponse={googleResponse}
          googleErrorResponse={googleErrorResponse}
          open={openRegister}
          setOpenLogin={setOpenLogin}
          handleClose={() => setOpenRegister(!openRegister)}
          successCallback={() => setOpenSuccessSignup(true)}
        />
      )}
      {openLogin && (
        <LoginPopUp
          open={openLogin}
          googleResponse={googleResponse}
          googleErrorResponse={googleErrorResponse}
          setOpenRegister={setOpenRegister}
          handleClose={() => setOpenLogin(!openLogin)}
        />
      )}
      {allowToShowHeader && <Header />}
      {children}
    </HeaderContext.Provider>
  );
};

export const useHeaderContext = () => {
  const context = useContext(HeaderContext);

  if (context === undefined) {
    throw new Error("HeaderProvider must be used within a HeaderProvider");
  }
  return context;
};
